export default "{{ transaction_totals[months] | currency:'USD':'symbol' }}\n<!-- | currency:'USD':'symbol' -->"